import styled from "styled-components";
import { colorPalette } from "./../../styleguide";

export const HorizontalDivider = styled.div`
  width: 100%;
  border: 0.75px solid ${colorPalette.lavender};
`;
